<template>
<a v-if="target == '_blank'" :class="variant" :href="url" class="button relative" target="_blank">
    <span class="label relative z-10">{{ label }}</span>
    <div class="effect-1 absolute left-0 top-0 pointer-events-none" aria-hidden="true"></div>
    <div class="effect-2 absolute left-0 top-0 pointer-events-none" aria-hidden="true"></div>
</a>
<Link v-else :class="variant" :href="url" class="button relative">
    <span class="label relative z-10">{{ label }}</span>
    <div class="effect-1 absolute left-0 top-0 pointer-events-none" aria-hidden="true"></div>
    <div class="effect-2 absolute left-0 top-0 pointer-events-none" aria-hidden="true"></div>
</Link>
</template>

<script>
import { ref, computed } from 'vue';

export default {

    props: {
        target: {
            type: String,
            required: false
        },
        url: {
            type: String,
            default: ''
        },
        label: {
            type: String,
            default: ''
        },
        variant: {
            type: String,
            default: 'button-1'
        }
    }

}
</script>